import { render, staticRenderFns } from "./DocsForm.vue?vue&type=template&id=559ce06a"
import script from "./DocsForm.vue?vue&type=script&lang=js"
export * from "./DocsForm.vue?vue&type=script&lang=js"
import style0 from "./DocsForm.vue?vue&type=style&index=0&id=559ce06a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports